import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes` from { opacity:0; } to { opacity:1; } `

export default styled.div`
  overflow-y: auto;
  height: ${document.body.clientHeight - 52}px;
  
  .row {
    margin: 43px 10px 55px 10px;
  }

  .grid {
    text-align: center;
    padding: 0;
    padding-right: 5px;
    margin-bottom: 78px;
    &:nth-child(even) {
      padding-right: 0;
      padding-left: 5px;
    }
  }

  .title {
    /* padding-top: 51px; */
    font-family: "ABChanel PB SemiBold L";
    font-size: 17px;
    font-weight: normal;
    margin: 51px auto 0;
    letter-spacing: -0.4px;
    text-align: center;
    html[lang=tw] & {
      font-size: 20px;
    }
  }

  .hot_items-title {
    width: 112px;
  }

  .cheat_codes-title {
    width: 171px;
  }

  .image,  .image-default{
    min-width: 46vw;
    min-height: 46vw;
    max-height: 100%;
    max-width: 100%;
    animation: ${fadeIn} ease-in 1;
    animation-fill-mode:forwards;
    animation-duration:1s;
  }

  .product-item-name {
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.45;
    letter-spacing: -0.3px;
    text-align: center;
    color: #000000;
    html[lang=tw] & {
      font-size: 14px;
    }
    &:first-child {
      margin-top: 24px;
    }
  }

  .cheat-code-label-wrapper {
    margin-bottom: -12px;
  }
  .cheat-code-label {
    display: inline-block;
    margin-top: 19px;
    padding: 5px 10px 6px;
    background-color: #000000;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 13px;
    font-weight: normal;
    line-height: 1.07;
    letter-spacing: -0.4px;
    text-align: center;
    color: #ffffff;
  }

  .product-group-label {
    display: inline;
    padding: 1px 5px 2px;
    /* margin: 8px auto 0px; */
    /* width: 74px; */
    min-height: 16px;
    background-color: #000000;

    /* display: flex;
    align-items: center;
    justify-content: center; */

    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 10px;
    /* line-height: 1.6; */
    letter-spacing: -0.4px;
    text-align: center;
    color: #ffffff;

    html[lang=tw] & {
      font-size: 12px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/ProductGroups.js